import { TextInput, TextInputProps } from "../form/TextInput";
import "./SearchInput.scss";

export const SearchInput = ({ ...props }: TextInputProps) => {
  return <TextInput {...props} className="search-input" />;
};
